import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon, TsrSvgIcon } from 'tacho-ui';
import { TachoTooltip } from '../TachoTooltip';
import styles from './styles.module.scss';

export function TachoFormWarning(props: { warningToTranslate: string; className?: string; size?: number }): JSX.Element {
    return (
        <TachoTooltip
            id="formWarning"
            content={<FormattedMessage id={props.warningToTranslate} />}
            className={`${styles.warningMessage} ${props.className}`}
        >
            <TsrSvgIcon icon={Icon.Exclamation} titleIcon className="titleIcon" />
        </TachoTooltip>
    );
}
